function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{mask:url(#SVGID_1_);fill:#7FC4FF;}\r\n\t.st3{fill:none;stroke:#0000FF;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st4{fill:#040000;}\r\n\t.st5{fill:#0000FF;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 13.558,
  y: 1.025,
  width: 49.537,
  height: 57.585
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
  colorInterpolationFilters: "sRGB",
  result: "source"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M21.814,1.025h41.281c-4.56,0-8.256,12.891-8.256,28.792s3.696,28.792,8.256,28.792H21.814 c-4.56,0-8.256-12.891-8.256-28.792S17.255,1.025,21.814,1.025z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M21.814,1.025h41.281c-4.56,0-8.256,12.891-8.256,28.792s3.696,28.792,8.256,28.792H21.814 c-4.56,0-8.256-12.891-8.256-28.792S17.255,1.025,21.814,1.025z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M10.841,33.36C6.094,31.412,3.5,29.304,3.5,27.104c0-9.914,52.657-17.951,117.613-17.951 s117.613,8.037,117.613,17.951c0,5.107-13.97,9.715-36.396,12.984"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M60.176,18.384h6.396c0.434,0,0.716,0.063,0.849,0.19c0.133,0.126,0.199,0.448,0.199,0.966 c0,0.47-0.045,0.799-0.135,0.985c-0.09,0.188-0.31,0.365-0.66,0.533c-0.313,0.145-0.512,0.301-0.596,0.47 c-0.084,0.169-0.126,0.445-0.126,0.831v21.447c0,0.313,0.036,0.542,0.109,0.687c0.072,0.145,0.271,0.295,0.596,0.451 c0.446,0.217,0.669,0.512,0.669,0.886c0,0.939-0.03,1.46-0.09,1.562c-0.061,0.103-0.271,0.154-0.632,0.154h-8.058 c-0.349,0-0.524-0.295-0.524-0.886c0-0.506,0.018-0.882,0.054-1.129c0.036-0.247,0.259-0.449,0.668-0.606 c0.458-0.181,0.687-0.5,0.687-0.957V28.754L56.327,41.04H54.34l-3.198-11.906v14.779c0,0.482,0.217,0.838,0.65,1.066 c0.53,0.265,0.795,0.735,0.795,1.409c0,0.771-0.265,1.157-0.795,1.157h-3.921c-0.446,0-0.669-0.367-0.669-1.102 c0-0.518,0.187-0.915,0.56-1.192c0.277-0.229,0.452-0.413,0.524-0.551c0.072-0.139,0.108-0.382,0.108-0.732V23.099 c0-0.578-0.051-1.02-0.153-1.328c-0.103-0.307-0.323-0.557-0.66-0.75c-0.361-0.193-0.542-0.392-0.542-0.596l0.018-0.777 c0.012-0.566,0.051-0.918,0.118-1.057c0.066-0.139,0.226-0.208,0.479-0.208h6.685l2.89,11.166L60.176,18.384z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M76.78,22.611c2.264,0,4.155,1.015,5.673,3.045c1.517,2.029,2.276,5.044,2.276,9.042 c0,4.312-0.771,7.574-2.313,9.783c-1.542,2.211-3.463,3.316-5.763,3.316c-1.59,0-2.969-0.506-4.137-1.518 c-1.169-1.012-2.069-2.361-2.701-4.048c-0.632-1.686-0.948-3.992-0.948-6.92c0-4.179,0.725-7.341,2.177-9.485 C72.494,23.684,74.406,22.611,76.78,22.611z M78.08,27.147c0-1.494-0.434-2.241-1.301-2.241c-0.939,0-1.409,0.916-1.409,2.747 v15.014c0,1.818,0.427,2.728,1.283,2.728c0.951,0,1.427-0.91,1.427-2.728V27.147z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M92.896,27.671c0.144-0.29,0.319-0.795,0.524-1.518c0.458-1.566,0.906-2.548,1.346-2.945 c0.44-0.397,0.925-0.596,1.455-0.596c0.722,0,1.267,0.343,1.635,1.03c0.367,0.687,0.551,1.548,0.551,2.584 c0,2.228-0.626,3.342-1.879,3.342c-0.627,0-1.108-0.367-1.445-1.102c-0.205-0.421-0.416-0.632-0.632-0.632 c-0.542,0-0.813,0.596-0.813,1.789v14.436c0,0.458,0.211,0.795,0.632,1.012c0.421,0.205,0.632,0.536,0.632,0.993v0.813 c0,0.289-0.033,0.472-0.099,0.551c-0.067,0.079-0.256,0.118-0.57,0.118h-6.811c-0.47,0-0.705-0.223-0.705-0.669v-0.994 c0-0.337,0.102-0.56,0.307-0.669c0.409-0.205,0.615-0.518,0.615-0.939V26.08c0-0.409-0.145-0.704-0.434-0.885 c-0.313-0.181-0.494-0.322-0.542-0.425c-0.048-0.102-0.072-0.413-0.072-0.93c0-0.434,0.063-0.704,0.19-0.813 c0.126-0.108,0.341-0.163,0.642-0.163h4.878c0.228,0,0.385,0.064,0.47,0.19c0.084,0.127,0.126,0.431,0.126,0.912V27.671z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M106.356,34.843v7.389c0,0.976,0.19,1.741,0.57,2.295c0.379,0.554,0.864,0.831,1.454,0.831 c0.915,0,1.647-0.388,2.195-1.165c0.548-0.777,0.841-1.84,0.876-3.189c0.012-0.722,0.082-1.156,0.208-1.301 c0.127-0.145,0.563-0.217,1.31-0.217c0.651,0,1.062,0.067,1.238,0.199c0.174,0.132,0.262,0.463,0.262,0.993 c0,1.855-0.602,3.505-1.807,4.95c-1.204,1.445-2.8,2.169-4.788,2.169c-2.276,0-4.209-1.033-5.8-3.099 c-1.589-2.066-2.385-5.176-2.385-9.332s0.735-7.32,2.204-9.495c1.47-2.174,3.397-3.261,5.782-3.261 c2.047,0,3.692,0.916,4.933,2.747c1.24,1.831,1.861,4.433,1.861,7.805v1.681H106.356z M108.795,32.585v-5.98 c0-1.132-0.404-1.698-1.21-1.698c-0.82,0-1.229,0.567-1.229,1.698v5.98H108.795z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M133.215,37.614v6.024c0,0.7,0.301,1.157,0.904,1.375c0.29,0.109,0.491,0.257,0.606,0.444 c0.114,0.187,0.171,0.533,0.171,1.04c0,0.483-0.066,0.781-0.198,0.895c-0.133,0.115-0.399,0.172-0.796,0.172h-8.195 c-0.434,0-0.651-0.38-0.651-1.14c0-0.602,0.03-0.974,0.091-1.112c0.06-0.139,0.265-0.262,0.615-0.371 c0.314-0.097,0.509-0.202,0.588-0.316s0.118-0.311,0.118-0.588V22.182c0-0.518-0.32-0.934-0.959-1.248 c-0.338-0.181-0.512-0.458-0.525-0.832l-0.018-0.851c0-0.361,0.045-0.599,0.136-0.715c0.09-0.114,0.292-0.171,0.606-0.171h9.262 c2.665,0,4.791,0.853,6.377,2.559c1.586,1.707,2.379,4.068,2.379,7.082c0,1.701-0.244,3.214-0.732,4.54 c-0.489,1.327-1.104,2.304-1.846,2.931c-0.742,0.627-1.598,1.14-2.569,1.538c-0.971,0.398-2.005,0.597-3.103,0.597H133.215z  M133.215,20.373v15.16h1.266c0.434,0,0.823-0.238,1.167-0.715c0.343-0.476,0.515-1.269,0.515-2.379v-9.027 c0-2.026-0.676-3.04-2.026-3.04H133.215z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M145.244,19.865v-0.903c0-0.385,0.253-0.578,0.759-0.578h5.582c0.301,0,0.5,0.024,0.596,0.072 c0.097,0.048,0.145,0.253,0.145,0.614v25.24c0,0.554,0.181,0.897,0.542,1.03c0.253,0.097,0.38,0.301,0.38,0.614v1.03 c0,0.374-0.272,0.56-0.813,0.56h-6.631c-0.373,0-0.56-0.187-0.56-0.56v-1.03c0-0.421,0.187-0.735,0.56-0.939 c0.241-0.12,0.392-0.232,0.452-0.334c0.06-0.103,0.09-0.298,0.09-0.588V21.708c0-0.422-0.163-0.704-0.488-0.849 C145.449,20.654,145.244,20.324,145.244,19.865z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M164.233,30.037v-3.486c0-0.964-0.392-1.445-1.175-1.445c-1.073,0-1.608,0.729-1.608,2.186 c0,0.82-0.093,1.403-0.28,1.753c-0.187,0.349-0.608,0.648-1.265,0.894c-0.656,0.247-1.358,0.371-2.105,0.371 c-1.53,0-2.295-0.819-2.295-2.457c0-1.542,0.666-2.801,1.997-3.776c1.331-0.976,3.068-1.464,5.213-1.464 c1.409,0,2.677,0.193,3.803,0.578c1.126,0.385,2.025,1.034,2.699,1.95c0.673,0.915,1.012,1.919,1.014,3.015v16.482 c0.024,0.084,0.205,0.265,0.542,0.542c0.241,0.181,0.361,0.446,0.361,0.795c0,0.482-0.066,0.822-0.198,1.021 c-0.132,0.198-0.455,0.382-0.967,0.551c-0.512,0.168-1.154,0.253-1.924,0.253c-0.939,0-1.723-0.172-2.348-0.515 c-0.627-0.343-1.115-1.014-1.463-2.014c-1.048,1.084-1.898,1.777-2.548,2.077c-0.651,0.301-1.319,0.452-2.006,0.452 c-1.527,0-2.71-0.599-3.549-1.796c-0.838-1.197-1.257-3.156-1.257-5.875c0.001-2.72,0.392-4.606,1.175-5.659 c0.782-1.052,2.312-2.025,4.588-2.915C162.083,31.001,163.281,30.495,164.233,30.037z M164.233,32.386 c-1.361,0.602-2.175,1.278-2.439,2.029c-0.265,0.752-0.398,2.445-0.398,5.078c0,1.937,0.109,3.16,0.325,3.672 c0.217,0.511,0.59,0.766,1.12,0.766c0.928,0,1.392-0.769,1.392-2.309V32.386z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M172.634,24.653V23.46c0-0.397,0.241-0.596,0.723-0.596h5.763c0.409,0,0.614,0.199,0.614,0.596v20.778 c0,0.289,0.018,0.476,0.054,0.56c0.035,0.084,0.142,0.162,0.319,0.234c0.426,0.169,0.639,0.543,0.639,1.12 c0,0.663-0.03,1.06-0.09,1.192c-0.06,0.133-0.252,0.199-0.577,0.199h-6.994c-0.168-0.024-0.276-0.1-0.325-0.226 c-0.047-0.127-0.072-0.461-0.072-1.003c0-0.65,0.156-1.03,0.469-1.138c0.385-0.132,0.578-0.373,0.578-0.722V26.442 c0-0.698-0.259-1.12-0.777-1.264C172.742,25.117,172.634,24.942,172.634,24.653z M177.694,17.733c1.361,0,2.041,0.458,2.041,1.373 c0,0.723-0.455,1.334-1.364,1.834c-0.91,0.5-1.942,0.75-3.099,0.75c-1.494,0-2.24-0.5-2.24-1.5c0-0.795,0.524-1.403,1.572-1.825 C175.652,17.944,176.682,17.733,177.694,17.733z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M189.203,25.322c1.433-1.807,3.071-2.71,4.914-2.71c1.259,0,2.221,0.407,2.886,1.22 c0.666,0.813,0.999,1.834,0.999,3.063v17.309c0,0.385,0.15,0.68,0.451,0.885c0.277,0.169,0.416,0.602,0.416,1.301 c0,0.554-0.045,0.886-0.135,0.994c-0.09,0.108-0.28,0.163-0.569,0.163h-5.077c-0.722-0.614-1.084-1.415-1.084-2.403V27.959 c0-0.939-0.385-1.409-1.156-1.409c-0.506,0-1.054,0.265-1.644,0.795v16.857c0,0.434,0.21,0.771,0.632,1.011 c0.253,0.145,0.379,0.41,0.379,0.795v0.922c0,0.409-0.295,0.614-0.885,0.614h-6.414c-0.314,0-0.512-0.045-0.596-0.135 c-0.085-0.09-0.127-0.317-0.127-0.678v-0.669c0-0.349,0.109-0.596,0.325-0.74c0.29-0.205,0.476-0.398,0.56-0.578 c0.084-0.181,0.126-0.578,0.126-1.192v-17.67c0-0.422-0.205-0.729-0.614-0.922c-0.229-0.108-0.343-0.301-0.343-0.578v-0.957 c0-0.374,0.169-0.56,0.506-0.56h5.89c0.253,0,0.409,0.037,0.469,0.109c0.061,0.072,0.091,0.223,0.091,0.451V25.322z"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: "0px",
    y: "0px",
    width: "243.12px",
    height: "60px",
    viewBox: "0 0 243.12 60",
    style: {
      enableBackground: "new 0 0 243.12 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 13.558,
    y: 1.025,
    width: 49.537,
    height: 57.585,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.3265,
    y1: 3.7437,
    x2: 38.3265,
    y2: 61.3284
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2894,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.709
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4262,
    style: {
      stopColor: "#0A0A0A",
      stopOpacity: 0.5714
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#171717",
      stopOpacity: 0.466
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    style: {
      stopColor: "#292929",
      stopOpacity: 0.3769
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    style: {
      stopColor: "#414141",
      stopOpacity: 0.2982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7688,
    style: {
      stopColor: "#5E5E5E",
      stopOpacity: 0.2268
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8343,
    style: {
      stopColor: "#818181",
      stopOpacity: 0.161
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8956,
    style: {
      stopColor: "#AAAAAA",
      stopOpacity: 0.0993
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9513,
    style: {
      stopColor: "#D7D7D7",
      stopOpacity: 0.0434
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _ref4)), _ref5, _ref6, _ref7));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.2385e611.svg";
export { ForwardRef as ReactComponent };